var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSuporte01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fones-de-ouvido",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_904",
    d: "M26.3,15.6V8.8C26.3,1.5,20.2-4.5,12.9-4.4C5.6-4.3-0.2,1.5-0.3,8.8v6.8c-2.4,0.5-4.1,2.6-4.1,5v0.1 c0,2.5,1.8,4.6,4.3,5c0.4,1.2,1.4,1.9,2.7,1.9h3.3v-14h-4v-0.7C1.8,6.7,6.9,1.7,13.1,1.8c6.1,0.1,11.1,5,11.2,11.2v0.7h-4v13.7 c0,0.6-0.5,1-1,1h-3.5c0.5-1.5-0.4-3.2-1.9-3.6c-1.5-0.5-3.2,0.4-3.6,1.9c-0.5,1.5,0.4,3.2,1.9,3.6c0.3,0.1,0.6,0.1,0.9,0.1 c0.1,0,0.1,0,0.2,0v0h6.1c1.6,0,2.9-1.2,3-2.7h1.2c1.2,0,2.3-0.8,2.7-1.9c2.5-0.4,4.2-2.6,4.3-5v-0.1 C30.4,18.2,28.7,16.1,26.3,15.6z M-2.4,20.7L-2.4,20.7c0-1.4,0.8-2.5,2.1-3v5.9C-1.5,23.2-2.4,22-2.4,20.7z M3.7,25.6H2.5 c-0.4,0-0.8-0.3-0.8-0.8v-9.2h2V25.6z M13-0.3c-4.1,0-8,1.9-10.5,5.2C4.7-1,11.2-3.9,17-1.7c3,1.1,5.3,3.5,6.5,6.5 C21,1.6,17.1-0.3,13-0.3L13-0.3z M12.1,27.5c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 C12.5,28.4,12.1,28,12.1,27.5z M23.5,25.6h-1.2v-9.9h2v9.2C24.3,25.3,23.9,25.6,23.5,25.6L23.5,25.6z M28.4,20.7 c0,1.3-0.8,2.5-2.1,2.9v-5.9C27.5,18.2,28.4,19.3,28.4,20.7L28.4,20.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSuporte01);
export default __webpack_public_path__ + "static/media/ico-suporte-01.4e2c9c0c06a4cea6613f8f3d5b157b7c.svg";
export { ForwardRef as ReactComponent };